// Maps a level to its PathCard variant by `rankName` rather than array position so a
// level's color stays stable across re-orderings, pagination changes, or custom ranks
// being inserted. `level.rankName` is the canonical rank slug (white/yellow/green/...)
// and stays the same regardless of which Level Theme the customer picks — themes only
// re-skin the display name, not the underlying rank — so this mapping is consistent for
// every customer. Brown/black are filtered out of learner-facing UI upstream; any
// unknown / custom rank falls through to mauve.
const RANK_VARIANTS = {
  white: "indigo",
  yellow: "blue",
  green: "teal",
};

export const getLevelVariant = level => RANK_VARIANTS[level?.rankName] ?? "mauve";
